import { PUZZLETAX_URL } from '../constants/puzzletax.js';

export default [
  {
    path: '/home',
    component: () => import('../views/pages/homepage/PageInfoLayout.vue'),
    children: [
      {
        path: '',
        name: 'home-page',
        beforeEnter: () => {
          window.location.href = PUZZLETAX_URL;
        },
        component: () => import('../views/pages/homepage/Home.vue'),
        meta: {
          fullResolutionSupport: true,
        },
      },
      {
        path: 'privacy-policy',
        redirect: () => {
          return {
            name: 'home-privacy-policy',
          };
        },
      },
      {
        path: 'polityka-prywatnosci',
        redirect: () => {
          return {
            name: 'home-privacy-policy',
          };
        },
      },
      {
        path: 'service-regulations',
        redirect: () => {
          return {
            name: 'home-service-regulations',
          };
        },
      },
      {
        path: 'regulamin',
        redirect: () => {
          return {
            name: 'home-service-regulations',
          };
        },
      },
      {
        path: 'changediary',
        alias: ['dziennik-zmian'],
        name: 'home-changediary',
        component: () => import('../views/pages/homepage/Changelog.vue'),
        meta: {
          fullResolutionSupport: true,
        },
      },
    ],
  },
  {
    path: '',
    component: () => import('../views/pages/homepage/PageInfoLayout.vue'),
    children: [
      {
        path: 'privacy-policy',
        name: 'home-privacy-policy',
        alias: ['polityka-prywatnosci'],
        component: () => import('../views/pages/homepage/pages/PrivacyPolicy'),
      },
      {
        path: 'service-regulations',
        alias: ['regulamin'],
        name: 'home-service-regulations',
        component: () => import('../views/pages/homepage/pages/ServiceRegulations'),
      },
    ],
  },
];
